import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi, getDisplayMessage } from '@/api/apiClient';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function EsqueciSenhaPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage(null);
    setLoading(true);
    try {
      await authApi.esqueciSenha(email.trim());
      setMessage({
        type: 'success',
        text: 'Se o e-mail existir em nossa base, você receberá um link para redefinir a senha. Verifique sua caixa de entrada e spam.',
      });
    } catch (err) {
      setError(getDisplayMessage(err, 'Erro ao enviar. Tente novamente.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-4">
      <Card className="w-full max-w-md shadow-xl border-none">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-4">
            <img
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68e50deef22388676f24e5ca/058df03c3_LogoAuction.png"
              alt="Auction Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-slate-900">Esqueci minha senha</CardTitle>
          <CardDescription className="mt-2">
            Informe seu e-mail para receber um link de redefinição
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {message?.type === 'success' && (
              <Alert className="border-green-200 bg-green-50 text-green-900">
                <AlertDescription>{message.text}</AlertDescription>
              </Alert>
            )}
            {error && (
              <Alert variant="destructive">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="mt-1"
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar link'}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-slate-600">
            <Link to="/Login" className="text-blue-600 hover:underline">
              Voltar para login
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
